const fisaCoolingOffClosureReasons = [
  { value: 'unhappy_with_interest_rates', label: "I'm unhappy with the interest rates" },
  { value: 'unhappy_with_service', label: "I'm unhappy with the service or product features" },
  { value: 'prefer_app_management', label: 'I would prefer to manage my account via an app' },
  { value: 'balance_below_minimum', label: 'My balance is below the minimum amount of £1,000' },
  { value: 'need_money_other_purpose', label: 'I need the money for another purpose' },
  { value: 'changed_mind_cancellation_period', label: 'I changed my mind during the cancellation period' },
  { value: 'wrong_account', label: 'I opened the wrong account by mistake' },
  { value: 'no_longer_eligible', label: "I'm no longer eligible (eg not a UK resident)" },
  { value: 'other', label: 'Other' },
];

export default fisaCoolingOffClosureReasons;
